export default __webpack_public_path__ + "static/card2_img-3180f6306d0c6c2b1055911b39871508.webp";